import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum selectFromOptionIds {
  CUSTOM = 1,
  SUPPLIERS = 2,
  LOCATIONS = 3,
}

export function getSelectFromOptions(): ISelectItem[] {
  return [
    { id: selectFromOptionIds.CUSTOM, label: 'Custom' },
    { id: selectFromOptionIds.SUPPLIERS, label: 'Suppliers' },
    { id: selectFromOptionIds.LOCATIONS, label: 'Locations' },
  ]
}

// V3 keys a divider off `item.type`, not a bare `divider: true` (see
// VList.js:25 / VSelect.js:514). Under the V2 shape it rendered as a
// blank, caption-less selectable row.
type TMenuDivider = { type: 'divider' }

export function getSelectFromOptionsMenu(): (ISelectItem | TMenuDivider)[] {
  const options = getSelectFromOptions() as (ISelectItem | TMenuDivider)[]
  options.splice(1, 0, { type: 'divider' })
  return options
}

export const getSelectFromOptionByLabel =
  getItemByLabelFactory(getSelectFromOptions)
export const getSelectFromOptionById = getItemByIdFactory(getSelectFromOptions)
